import axios from 'axios';
import config from '../config';
import setupApiInterceptors from '../services/apiInterceptor';

const API_BASE_URL = config.apiBaseUrl || process.env.REACT_APP_API_BASE_URL || "https://dashboards.hisglobaltech.com/admin-dashboard";
const env = config.environment || process.env.REACT_APP_ENVIRONMENT;
//let env = process.env.REACT_APP_ENVIRONMENT;
// Create axios instance for API calls
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000
});

// Setup automatic token refresh interceptors
setupApiInterceptors(apiClient);

export { apiClient };

export const fetchTicketsSold = async (startDate, endDate, accessToken, environment = env, dateRangeOption = 'custom') => {
    try {
        let endpoint;
        let params = { environment };

        // Determine which endpoint to use based on dateRangeOption
        if (dateRangeOption === 'current-month') {
            endpoint = `${API_BASE_URL}/api/Tickets/current-month`;
            console.log('Fetching tickets from API:', endpoint);
            console.log('Environment:', environment);
        } else if (dateRangeOption === 'previous-month') {
            endpoint = `${API_BASE_URL}/api/Tickets/previous-month`;
            console.log('Fetching tickets from API:', endpoint);
            console.log('Environment:', environment);
        } else {
            // Custom date range
            endpoint = `${API_BASE_URL}/api/Tickets/date-range`;
            params.startDate = startDate.toISOString().split('T')[0];
            params.endDate = endDate.toISOString().split('T')[0];
            console.log('Fetching tickets from API:', endpoint);
            console.log('Environment:', environment);
            console.log('Date Range:', `${params.startDate} to ${params.endDate}`);
        }

        console.log('Token:', accessToken ? `${accessToken.substring(0, 20)}...` : 'No token');

        // Use apiClient instead of axios to get automatic token refresh on 401
        const response = await apiClient.get(endpoint, {
            params,
            headers: {
                'Content-Type': 'application/json'
            }
        });

        console.log('API Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching tickets:', error.response?.data || error.message);
        throw error;
    }
};

export const downloadTicketsReport = async (startDate, endDate, accessToken, environment = env, dateRangeOption = 'custom') => {
    try {
        let endpoint;
        let params = { environment };

        // Determine which endpoint to use based on dateRangeOption
        if (dateRangeOption === 'current-month') {
            endpoint = `${API_BASE_URL}/api/Reports/current-month`;
            console.log('Downloading report from API:', endpoint);
            console.log('Environment:', environment);
        } else if (dateRangeOption === 'previous-month') {
            endpoint = `${API_BASE_URL}/api/Reports/previous-month`;
            console.log('Downloading report from API:', endpoint);
            console.log('Environment:', environment);
        } else {
            // Custom date range
            endpoint = `${API_BASE_URL}/api/Reports/date-range`;
            params.startDate = startDate.toISOString().split('T')[0];
            params.endDate = endDate.toISOString().split('T')[0];
            console.log('Downloading report from API:', endpoint);
            console.log('Environment:', environment);
            console.log('Date Range:', `${params.startDate} to ${params.endDate}`);
        }

        // Use apiClient for automatic token refresh on 401
        const response = await apiClient.get(endpoint, {
            params,
            responseType: 'blob'
        });

        // Create a blob URL and open in new tab
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', `tickets-report-${new Date().toISOString().split('T')[0]}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

        console.log('✓ Report downloaded successfully');
    } catch (error) {
        console.error('Error downloading report:', error.response?.data || error.message);
        throw error;
    }
};

export const searchMetadata = async (environment = env, metadataPath, accessToken) => {
    try {
        console.log('Searching metadata from API:', `${API_BASE_URL}/api/metadata`);
        console.log('Environment:', environment);
        console.log('Metadata Path:', metadataPath);

        const payload = {
            environment,
            metadataPath
        };

        // Use apiClient for automatic token refresh on 401
        const response = await apiClient.post(`/api/metadata`, payload, {
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: 'text'
        });

        console.log('Metadata Response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error searching metadata:', error.response?.data || error.message);
        throw error;
    }
};